import { render } from "./unitsheader.vue?vue&type=template&id=37182676"
import script from "./unitsheader.vue?vue&type=script&lang=js"
export * from "./unitsheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__